import { Component, computed, inject, model, signal } from '@angular/core';

import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import {
  Transaction,
  TransactionStatus,
} from '../../../../shared/schemas/transaction';
import { TransactionService } from '../../../../shared/services/transaction.service';
import { ModalComponent } from '../../../../shared/ui/modal/modal.component';
import { ModalService } from '../../../../shared/utils/services/modal.service';

@Component({
  selector: 'qwiko-transactions-breakdown',
  imports: [CommonModule, ModalComponent, TranslocoModule],
  templateUrl: './transactions-breakdown.component.html',
  styleUrl: './transactions-breakdown.component.scss',
})
export class TransactionsBreakdownComponent {
  modalService = inject(ModalService);
  transactionServices = inject(TransactionService);
  transactionStatus = TransactionStatus;
  transactions = model.required<Transaction[]>();
  initiatedTransactions = computed(() => {
    const initiated = this.transactions().filter((transaction) => {
      return transaction.status === this.transactionStatus.INITIATED;
    });
    return initiated.length;
  });
  confirmedTransactions = computed(() => {
    const confirmed = this.transactions().filter((transaction) => {
      return transaction.status === this.transactionStatus.CONFIRMED;
    });
    return confirmed.length;
  });
  canceledTransactions = computed(() => {
    const canceled = this.transactions().filter((transaction) => {
      return transaction.status === this.transactionStatus.CANCELED;
    });
    return canceled.length;
  });

  pendingTransactions = computed(() => {
    const pending = this.transactions().filter((transaction) => {
      return transaction.status === this.transactionStatus.PENDING;
    });
    return pending.length;
  });

  closeModal(modal: string) {
    this.modalService.close(modal);
  }
}
